import { useContextSelector } from "use-context-selector";
import { IStore, StoreContext } from "store";

export const useConnectionsSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => {
    return store.dataRooms.connections;
  });

export const useConnectionSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => {
    return store.dataRooms.connection;
  });

export const useDataroomsConnectMsgSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => {
    return store.dataRooms.connectMessage;
  });

export const usePlatformsSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => {
    return store.dataRooms.platforms;
  });
